import Image from 'next/image';

import type { Image as ImageType } from '@/blocks/image';

interface ImageProps {
  block: ImageType;
}

export const ImageBlock = ({ block }: ImageProps) => {
  return (
    <div className="w-full space-y-2">
      <Image
        src={block.image.url}
        width={1600}
        height={900}
        className="object-contain"
        alt=""
      />
      {block.caption && (
        <p className="text-sm italic text-cream">{block.caption}</p>
      )}
    </div>
  );
};
